

































import { Component, Prop, Vue } from 'vue-property-decorator'
import { getUserInfo } from '@/api'

@Component
export default class HelloWorld extends Vue {
  @Prop() private msg!: string;

  constructor () {
    super()
    getUserInfo({ uid: 5146121874, areaId: 3 })
  }
}
